import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: center;
  justify-content: center;
  align-items: center;
  background-color: #000;
`;

export const Slider = styled.div`
  width: 100%;
  max-width: 100vw;
  height: 25vw;
  max-height: 200px;
  position: relative;
`;

export const ImgBanner = styled.img`
  opacity: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 800ms;
  &:hover {
    cursor: pointer;
  }
`;

export const Action = styled.a`
  :link {
    color: #000;
  }
  :visited {
    color: #000;
  }
  :hover {
    color: #0001;
  }
  :active {
    color: #000;
  }
`;
